import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import useLookupModule from '../../../../../hooks/Lookups/use-Lookup-Module';
import { Card, CardBody } from '../../../../../components/card/card';
import { useAppDispatch, useAppSelector } from '../../../../../store/hooks';
import Breadcrumb from '../../../../../components/Shared/Breadcrumb';
import { usePermissions } from '../../../../../Helper/Permisstions/usePermissions';
import MngTemplates from '../MngTemplates';
import { GetNtxPrintTemplatesList } from '../../../../../store/NTX/PrintTemplate/PrintTemplateSlice';
import Loading from '../../../../../components/Shared/Loader/Loading';
import NeatixModal from '../../../../../components/Modal/NeatixModal';
import Notes from '../Notes';
import NtxTable from '../../../../../components/DataTable/NtxTable.jsx';

interface LookupModule {
  Module: any[];
}

function Index() {
  const { HasPermission } = usePermissions();

  const [templateId, setTemplateId] = useState<string>('');
  const { t, i18n } = useTranslation();
  const [search, setSearch] = useState<string>('');

  const dispatch = useAppDispatch();

  const [show, setShow] = useState(false);
  const [showModal, setShowModal] = useState(false);

  //__________________________________________________
  const { PrintTemplateList, loading, error } = useAppSelector((state) => state.PrintTemplate);
  useEffect(() => {
    if (PrintTemplateList?.length === 0) {
      dispatch(GetNtxPrintTemplatesList());
    }
  }, [dispatch]);

  //_____________________________________________________

  const [selectedValue, setSelectedValue] = useState('');
  const { Module }: LookupModule = useLookupModule();

  //_________________________________________________________________________________________________

  const filteredSearch = PrintTemplateList?.slice()
    ?.filter((item) => {
      const searchLowerCase = search.toLowerCase();
      return (
        item.name?.toLowerCase().includes(searchLowerCase) ||
        item.name2?.toLowerCase().toString().includes(searchLowerCase)
      );
    })
    ?.filter((f) => (selectedValue === '' ? true : f.moduleId === selectedValue));

  const columns = [
    { title: t('TemplateName'), key: 'Name' },
    { title: t('Application'), key: 'Application' },
    { title: t('Icon'), key: 'icon' },
    { title: t(''), key: 'action', className: 'text-end' },
  ];

  const tableData = filteredSearch?.map((item) => {
    let rowClass;
    const module = Module?.find((f: { id: string }) => f?.id === item?.moduleId);

    return {
      Name: i18n.language === 'ar' ? item.name2 : item.name,
      Application: module ? (i18n.language === 'en' ? module.name : module.name2) : '',
      icon: (
        <div className="text-theme fs-4">
          <i className={item.icon}></i>
        </div>
      ),
      action: (
        <>
           {HasPermission('NtxPrintingFormsSetting') && (
            <button
              type="button"
              className="btn btn-outline-theme ms-1"
              onClick={() => {
                setTemplateId(item.id);
                setShow(true);
              }}>
              <i className=" text-theme fa-lg fa-fw me-1 bi bi-file-earmark-text"></i>
              {t('TemplateSettings')}
            </button>
          )}
          {HasPermission('NtxEditPrintingForms') && (
            <button
              type="button"
              className="btn btn-outline-theme ms-1"
              onClick={() => {
                const newLocation = `PrintingForms/${item.id}/UpdatePrintingForms`;
                window.location.href = newLocation;
              }}>
              <i className="far fa-lg fa-fw me-1  fa-edit"></i>
              {t('Edit')}
            </button>
          )}
        </>
      ),

      rowClass, // استخدم rowClass هنا
    };
  });

  //____________________________
  var BcrumbList = [
    {
      name: 'Home',
      link: ':moduleHome',
    },
    {
      name: t('ManagingPrintingTemplates'),
      link: null,
    },
  ];

  return (
    <>
      <div className="d-flex align-items-center">
        <Breadcrumb BreadcrumbList={BcrumbList} PageName={t('ManagingPrintingTemplates')} />
        <div className="ms-auto">
          <Link to="" className="btn me-1 btn-theme" onClick={() => setShowModal(true)}>
            <i className="fa fa-info-circle fa-fw me-1"></i>
            {t('TemplateConstructionExplanations')}
          </Link>
          {HasPermission('NtxAddPrintingForms') && (
            <Link to="AddPrintingForms" className="btn me-1 btn-theme">
              <i className="fa fa-plus-circle fa-fw me-1"></i>
               {t('AddNewTemplates')}
            </Link>
          )}
        </div>
      </div>
      <Card>
        <Loading loading={loading} error={error}>
          <CardBody>
            <div className="row">
              <div className="col-xl-6">
                <div className="input-group flex-nowrap mb-2">
                  <span className="input-group-text">{t('Application')}</span>
                  <Select
                    classNamePrefix="react-select"
                    className="w-100"
                    isSearchable={true}
                    isClearable
                    options={
                      Module &&
                      Module?.map((item: any) => ({
                        value: item.id,
                        label: i18n.language === 'ar' ? item.name2 : item.name,
                      }))
                    }
                    onChange={(option: any) => {
                      setSelectedValue(option === null ? null : option.value);
                    }}
                    placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                  />
                </div>
              </div>
              <div className="col-xl-6">
                <div className="input-group flex-nowrap mb-2">
                  <span className="input-group-text">{t('Search')}</span>
                  <input
                    type="text"
                    autoComplete="off"
                    className="form-control "
                    onChange={(e) => {
                      setSearch(e.target.value);
                    }}
                  />
                </div>
              </div>
            </div>

            <NtxTable
              data={tableData || []}
              columns={columns}
              dataPerPage={10}
              theadClass=""
              tableClass="table text-nowrap table-hover "
            />
          </CardBody>
        </Loading>
      </Card>

      <NeatixModal show={show} setShow={setShow} size="xl" bodyClassName="p-2" showHeader={false}>
        {templateId && <MngTemplates templateId={templateId} onClose={() => setShow(false)} />}
      </NeatixModal>

      <NeatixModal
        show={showModal}
        setShow={setShowModal}
        size="lg"
        bodyClassName="p-2"
        showHeader={false}>
        <Notes onClose={() => setShowModal(false)} />
      </NeatixModal>
    </>
  );
}

export default Index;
